import SectionHeading from '../../global/HeadingOne';
import SingleCoolFact from './SingleCoolFact';
import ausImg from '../../../assets/images/aus-map.jpg';

export default function CoolFacts() {
    return(
        <div className="cool-facts-wrapper">
            {/* Circle Animation */}
            <div className="circle-animation">
                <div className="circle1" />
                <div className="circle2" />
                <div className="circle3" />
                <div className="circle4" />
            </div>

            {/* Background Image */}
            <div className="cta-background-image">
                <img src={ausImg} alt="" />
            </div>

            {/* Heading: src > components > heading > Heading */}
            <SectionHeading
                subtitle=" "
                heading="הצטרפו אלינו ליבשת הלוהטת בעולם שנותנת הכל בחבילה אחת."
            />

            <div className="container">
                <div className="row g-4 justify-content-center">
                    {/* Single Cool Fact */}
                    <SingleCoolFact 
                        countUpValue="120" 
                        suffix="+" 
                        title="אתרי צלילה"
                    />
                    
                    {/* Single Cool Fact */}
                    <SingleCoolFact 
                        countUpValue="6500" 
                        suffix="+" 
                        title="מקומות בילוי"
                    />
                    
                    {/* Single Cool Fact */}
                    <SingleCoolFact 
                        countUpValue="5000" 
                        suffix="+" 
                        title="מסלולי טראק"
                    />
                </div>
            </div>
        </div>
    )
}